import React, { memo } from 'react'
import PropTypes from 'prop-types'
import './form.scss'

const FormComponent = ({ children }) => (
  <form className="form" onSubmit={(e) => e.preventDefault()}>
    {children}
  </form>
)

FormComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default memo(FormComponent)
